import { render, staticRenderFns } from "./Pt.vue?vue&type=template&id=2ae5381c&scoped=true&"
import script from "./Pt.vue?vue&type=script&lang=js&"
export * from "./Pt.vue?vue&type=script&lang=js&"
import style0 from "./Pt.vue?vue&type=style&index=0&id=2ae5381c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae5381c",
  null
  
)

export default component.exports